import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from './notification.service';
import { AuthService } from './auth.service';
import { NgxUiLoaderService } from "ngx-ui-loader";

@Injectable({ providedIn: 'root' })
export class GeneralService {
    constructor(private http: HttpClient, private notificationService: NotificationService, private authService: AuthService,
                private loaderService: NgxUiLoaderService) {
    }

    getData(path: any, notifyError: boolean = true, loading = true) {
        if (loading) { this.loaderService.start(); }
        return new Promise((resolve, reject) => {
            this.http.get(path, { observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body; 
                    const success = this.notificationService.verifyStatus(response, false);
                    if (loading) { this.loaderService.stop(); }
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if (loading) { this.loaderService.stop(); }
                    reject(error);
                });
        });
    }

    getParamsData(path: any, params: any, notifyError: boolean = true, loading = true) {
        if (loading) { this.loaderService.start(); }
        return new Promise((resolve, reject) => {
            this.http.get(path, { params, observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body; 
                    const success = this.notificationService.verifyStatus(response, false);
                    if (loading) { this.loaderService.stop(); }
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else  if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if (loading) { this.loaderService.stop(); }
                    reject(error);
                });
        });
    }

    getFilterData(path: any, body: any, params: any, notifyError: boolean = true, loader: boolean = true) {
        if(loader) this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.post(path, body, { params, observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body; 
                    const success = this.notificationService.verifyStatus(response, false);
                    if(loader) this.loaderService.stop();
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if(loader) this.loaderService.stop();
                    reject(error);
                });
        });
    }

    getDataById(path: any, id: any, params?: any, notifyError: boolean = true, loader: boolean = true) {
        if(loader) this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.get(path + "/" + id, { params, observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, false);
                    if(loader) this.loaderService.stop();
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if(loader) this.loaderService.stop();
                    reject(error);
                });
        });
    }

    getDataWithPIN(path: any, notifyError: boolean = true, loading = true, pin:string="") {
        let headers = new HttpHeaders();
        headers = headers.set('codepin', pin);
        if (loading) { this.loaderService.start(); }
         return new Promise((resolve, reject) => {
            this.http.get(path, { headers, observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, false);
                    if (loading) { this.loaderService.stop(); }
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if (loading) { this.loaderService.stop(); }
                    reject(error);
                });
        });
    }

    CreateOrUpdateData(path: any, body: any, method: any, notifyError: boolean = true, loader: boolean=true) {
       if(loader){this.loaderService.start()};
        return new Promise((resolve, reject) => {
            this.http[method]<any>(path, body, { observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, true);
                    if(loader){this.loaderService.stop()};
                    resolve(success);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if(loader){this.loaderService.stop()};
                    reject(error);
                });
        });
    }

    CreateOrUpdateDataResponse(path: any, body: any, method: any, notify = true, notifyError: boolean = true, pinRequire?: boolean , strPin?:string, loader: boolean=true) {
        if(loader){this.loaderService.start();}
        let headers = new HttpHeaders();
        if(pinRequire){            
            headers = headers.set('codepin', strPin);
        }
        return new Promise((resolve, reject) => {
            this.http[method]<any>(path, body, { headers, observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, notify);
                    if(loader){this.loaderService.stop();}
                    resolve({ success: success, data: response.data ? response.data : null, estado: response.estado ? response.estado : null });
                },
                (error: any) => {

                    if (notifyError &&(!navigator.onLine || error.status === 0)) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) {this.notificationService.verifyStatus(error.error, true);}
                    if(loader){this.loaderService.stop();}
                    reject(error);
                });
        });
    }

    patchData(path: any, body: any, notify = true, notifyError: boolean = true) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http['patch']<any>(path, body, { observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, notify);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    patchDataResponse(ruta: any, body: any, notify = true, notifyError: boolean = true) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http['patch']<any>(ruta, body, { observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, notify);
                    this.loaderService.stop();
                    resolve({ success: success, data: response?.data });
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    putData(path: any, body: any, notifyError: boolean = true) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.put(path, body, { observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    deleteData(path: string, id?: number, params?: any, notifyError: boolean = true) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            const newPath = id ? path + '/' + id : path;
            this.http.delete(newPath, { params, observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    if (!navigator.onLine || error.status === 0) {
                        this.notificationService.error({error: 'Ha ocurrido un error, verifique su conexión a internet'}, "Ha ocurrido un error, verifique su conexión a internet");
                    } 
                    else if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }
    deleteWithoutId(path: any, notifyError: boolean = true) {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.delete(path, { observe: 'response' }).subscribe(
                (result: any) => {
                    this.validateNewToken(result);
                    const response = result.body;
                    const success = this.notificationService.verifyStatus(response, true);
                    this.loaderService.stop();
                    resolve(success);
                },
                (error: any) => {
                    if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    this.loaderService.stop();
                    reject(error);
                });
        });
    }

    convertDateToString(fecha: Date) {
        return fecha.toISOString().split('T')[0];
    }

    postFomData(path: any, file: File, fields: any, notifyError: boolean = true, loading = true) {
        if (loading) { this.loaderService.start(); }
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            Object.keys(fields).forEach(key => {
                formData.append(key, fields[key]);
            });
            formData.append('file', file);
            const headers = new HttpHeaders({ 'provider': "AWS" });
            this.http.post(path, formData, { headers }).subscribe(
                (response: any) => {
                    const success = this.notificationService.verifyStatus(response, false);
                    if (loading) { this.loaderService.stop(); }
                    if (success) resolve(response.data);
                    resolve(null);
                },
                (error: any) => {
                    if (notifyError && error && error.error) this.notificationService.verifyStatus(error.error, true);
                    if (loading) { this.loaderService.stop(); }
                    reject(error);
                });
        });
    }

    validateNewToken(response: any)
    {
        const newToken = response.headers.get('x-new-token');
        if(newToken) this.authService.setToken(newToken);
    }

}